// Membership tiers - the spending-power model from the business plan.
// Fees stored in cents.

export type Tier = {
  tier: number;
  name: string;
  monthlyFeeCents: number;
  spendingPowerCents: number;
  feePctOfPower: string;
  blurb: string;
  perks: string[];
};

// Everyone who finishes onboarding gets $50,000 of free spending power, once.
export const ONBOARDING_BONUS_CENTS = 50_000_00;

export const FOUNDING_DISCOUNT = 0.3; // 30% off, first 50 buyers, permanent
export const FOUNDING_SEATS = 50;

export const TIERS: Tier[] = [
  {
    tier: 5,
    name: "Starter",
    monthlyFeeCents: 299_00,
    spendingPowerCents: 15_000_00,
    feePctOfPower: "2%",
    blurb: "Test the waters with cost pricing on every drop.",
    perks: [
      "Unlock cost price on all listings",
      "$15,000 spending power",
      "Drop alerts by text + email",
      "Standard drop access",
    ],
  },
  {
    tier: 1,
    name: "Access",
    monthlyFeeCents: 999_00,
    spendingPowerCents: 50_000_00,
    feePctOfPower: "2%",
    blurb: "Unlock cost pricing and enter every drop.",
    perks: [
      "Unlock cost price on all listings",
      "Custom worldwide freight",
      "Personal account manager",
      "Drop alerts by text + email",
      "Standard drop access",
    ],
  },
  {
    tier: 2,
    name: "Operator",
    monthlyFeeCents: 2_499_00,
    spendingPowerCents: 150_000_00,
    feePctOfPower: "1.7%",
    blurb: "Built for resellers moving real volume.",
    perks: [
      "Everything in Access",
      "$150,000 spending power",
      "Priority queue on live drops",
      "Take-all lots on eligible listings",
    ],
  },
  {
    tier: 3,
    name: "Scale",
    monthlyFeeCents: 4_999_00,
    spendingPowerCents: 500_000_00,
    feePctOfPower: "1%",
    blurb: "Serious buying power across every category.",
    perks: [
      "Everything in Operator",
      "$500,000 spending power",
      "Early access to drops",
      "Concierge custom sourcing requests",
    ],
  },
  {
    tier: 4,
    name: "Corporate",
    monthlyFeeCents: 4_999_00,
    spendingPowerCents: 500_000_00,
    feePctOfPower: "1%",
    blurb: "Maximum leverage. Move a warehouse in one order.",
    perks: [
      "Everything in Scale",
      "Custom spending power above $500,000",
      "First right of refusal on anchor lots",
      "Dedicated sourcing line + wire desk",
    ],
  },
];

export function getTier(tier: number): Tier | undefined {
  return TIERS.find((t) => t.tier === tier);
}

export function foundingFeeCents(baseCents: number): number {
  return Math.round(baseCents * (1 - FOUNDING_DISCOUNT));
}
